import cn from 'clsx'
import s from './ScanSections.module.scss'
import { FC, useRef } from 'react'
import { Text, CustomImage, Container, Button } from '@components/ui'
import { useWindowSize } from '@hooks/useWindowSize'

import { LoreThreeDetailPageSectionsInner } from '@generated/model/loreThreeDetailPageSectionsInner'
import ScanSection from './ScanSection'

type ScanSectionProps = {
  sections: LoreThreeDetailPageSectionsInner[]
}

const ScanSections: FC<ScanSectionProps> = ({ sections }) => {
  return (
    <>
      <section className={s.root}>
        <Container>
          <div className={s.grid}>
            {sections.map((section, index) => (
              <ScanSection key={`section-${index}`} section={section} />
            ))}
          </div>
        </Container>
      </section>
    </>
  )
}

export default ScanSections
